module.exports = __webpack_public_path__ + "static/media/checklist.04b6e843.png";